import { render, staticRenderFns } from "./StockPurchaseOrderRequestedItemsTable.vue?vue&type=template&id=6cc8015c&scoped=true&"
import script from "./StockPurchaseOrderRequestedItemsTable.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderRequestedItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./StockPurchaseOrderRequestedItemsTable.vue?vue&type=style&index=0&id=6cc8015c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc8015c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCol,VDataTable,VRow,VTextField})
